import useOutputReportStore from "../../../../store/OutputReport.store";
import {
  extractRowKeys,
  oldExtractRowKeys,
  formatDataTableColumns,
  oldFormatDataTableColumns,
} from "../../../../utils/helpers/dataTable";
import { reactJsonToJsx } from "../../../../utils/reactJsonToJsx";
import DataTable from "../../../DataTable";

import "./ProposedPortfolioDataTable.scss";

const ProposedPortfolioDataTable = () => {
  const types = useOutputReportStore((state) => state.types);
  const sectionMetadata = useOutputReportStore().metadata?.Portfolio;
  const { footnotes, data, table1 } = sectionMetadata || {};

  if (!sectionMetadata) return null;

  return (
    <DataTable
      {...sectionMetadata}
      name={"targetPorfolio"}
      tableRowKeys={oldExtractRowKeys(sectionMetadata)}
      variation="stylized"
      tableColumns={oldFormatDataTableColumns(sectionMetadata)}
      tableRowHeaderKey={"Security Code"}
      tableCaption={`Target Portfolio [1] Data Table`}
      formatCellDataBy="row"
      tableDataTypes={types?.Portfolio}
      // footnote={reactJsonToJsx(footnotes)}
    />
  );
};

ProposedPortfolioDataTable.propTypes = {};

ProposedPortfolioDataTable.defaultProps = {};

export default ProposedPortfolioDataTable;
